import ReactDynamicFont from "react-dynamic-font";
import { FiInfo } from "react-icons/fi";
import { Skeleton } from "@mui/material";
import Popover from "../../../../components/Popover";
import {
  CardValue,
  IconContainer,
  Info,
  MiniCardBox,
  MiniHeader,
  ContentWrapper,
  HeaderContent
} from "./styles";

interface NumberCardProperties {
  icon: React.ReactNode;
  title: string;
  value: number | string;
  hasAditionalInfo?: boolean;
  aditionalInfo?: string;
  isLoading?: boolean;
}

export function NumberCardBox({
  icon,
  title,
  value,
  hasAditionalInfo = false,
  aditionalInfo,
  isLoading = false,
}: NumberCardProperties) {
  return (
    <MiniCardBox>
      <IconContainer>{icon}</IconContainer>
      
      <ContentWrapper>
        <HeaderContent>
          <MiniHeader>{title}</MiniHeader>
          {hasAditionalInfo && (
            <Popover label={aditionalInfo} position="left">
              <Info display={hasAditionalInfo}>
                <FiInfo />
              </Info>
            </Popover>
          )}
        </HeaderContent>
        <CardValue>
          {isLoading ? (
            <Skeleton variant="text" width="60%" height={32} />
          ) : (
            <ReactDynamicFont content={value.toString()} />
          )}
        </CardValue>
      </ContentWrapper>
    </MiniCardBox>
  );
}
